export default [
  {
    path: '/b2bhub/operacoes/devolucoes',
    name: 'devolucoes',
    component: () => import('@/views/app/operacoes/devolucoes/devolucoes.vue'),
    meta: {
      pageTitle: 'Devoluções e Trocas',
      action: 'read',
      resource: 'Devolucoes',
    },
  },
  {
    path: '/b2bhub/operacoes/devolucoes/:id',
    name: 'devolucoes-detalhes',
    component: () => import('@/views/app/operacoes/devolucoes/DetalhesDevolucao.vue'),
    meta: {
      pageTitle: 'Devoluções e Trocas',
      action: 'read',
      resource: 'Devolucoes',
    },
  },
];
